<template>
  <alert-message v-if="showMessage" v-bind="$attrs" @close="hide">
    <slot/>
  </alert-message>
</template>

<script>
import AlertMessage from '@/components/AlertMessage';

export default {
  name: 'special-message',
  components: {
    AlertMessage,
  },
  data () {
    return {
      timer: null,
      showMessage: false,
    };
  },
  beforeDestroy () {
    clearTimeout(this.timer);
  },
  methods: {
    trigger (time = 2000) {
      clearTimeout(this.timer);
      this.showMessage = true;
      if (typeof time === 'number' && time > 0) {
        this.timer = setTimeout(() => { this.showMessage = false; }, time);
      }
    },
    hide () {
      clearTimeout(this.timer);
      this.showMessage = false;
    },
  },
};
</script>
